export default {
  updateProjectDetail(state, data) {
    state.projectDetail = data
  },
  updateCheckBdUser(state, data) {
    state.checkBdUser = data
  },
  updateGroupDetail(state, data) {
    state.groupDetail = data
  },
  updateDishesRecordInfo(state, data) {
    state.dishesMatchDetail.recordInfo = data
  },
}
